import { Pressable, Text } from 'dripsy';
import * as React from 'react';
import { AutocompleteItemLabel } from './AutocompleteItemLabel';
export const AutocompleteItem = ({ label, keyword, isHovered, isSelected, ...props }) => (React.createElement(Pressable, { sx: {
        flex: 1,
        justifyContent: 'center',
        paddingLeft: '$7',
        paddingRight: '$3',
        ...(isHovered && {
            backgroundColor: 'backgroundWeak',
        }),
    }, accessible: true, accessibilityLabel: label, accessibilityRole: "option", "aria-selected": isHovered, ...props },
    React.createElement(Text, { sx: {
            lineHeight: '$2',
            fontWeight: 'normal',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        } },
        React.createElement("span", { title: label },
            React.createElement(AutocompleteItemLabel, { label: label, keyword: keyword })))));
//# sourceMappingURL=AutocompleteItem.js.map